import { axiosChartInstance } from "config";
import { useAxiosMutation } from "hooks";
import { useQueryClient } from "react-query";
import { PatchVitalParams, PatchVitalPayload } from "modules/vitals/types";

function usePatchVitalCheck(params: PatchVitalParams) {
  const queryClient = useQueryClient();
  const { encounterId } = params;
  return useAxiosMutation(
    ["patchVitalCheck"],
    ({ vitalCheckId, payload }: PatchVitalPayload) =>
      axiosChartInstance.patch(
        `v1/vitals/${encounterId}/vital-check/${vitalCheckId}`,
        payload
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["vitals"]);
        queryClient.invalidateQueries([
          "chartApplicationHardStops",
          { encounterId, chartType: "Triage" },
        ]);
        queryClient.refetchQueries({
          queryKey: [
            "chartApplicationHardStops",
            { encounterId, chartType: "Triage" },
          ],
          active: false,
          inactive: true,
          predicate: (query) => query.getObserversCount() > 0,
        });
        queryClient.invalidateQueries(["chartPatientCard", { encounterId }]);
      },
    }
  );
}

export { usePatchVitalCheck };
